import React, { useState, useEffect, useCallback } from "react";
import "bootstrap/dist/css/bootstrap.css";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import * as constantMessages from "../../constants/constatntMessages";
import {
  getImmediateFollowOnMeetingDetails,
  getSingleMeetingDetails,
  newMeetingAsRescheduled,
  rescheduleMeeting,
  setErrorMessage,
} from "../../redux/actions/meetingActions/MeetingAction";
import { addMinutesInHours, checkCharacterLeft, currentTime, getRoundedTime } from "../../helpers/commonHelpers";
import LoaderButton from "../Common/LoaderButton";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import SmallLoaderButton from "../Common/SmallLoaderButton";
const regularExpressionForAgendaTitle =
  /^[0-9a-zA-Z .,:\n;%@&#!$^*+=`~()/_'"\\\-?|{}\[\]]+$/;
dayjs.extend(utc);
dayjs.extend(timezone);
const RescheduleMeetingModal = React.memo((props) => {
  
  const [isAmPm, setIsAmPm] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isPreviousChildMeetingAvailable, setIsPreviousChildMeetingAvailable] =
    useState(false);
  const [previousChildMeetingData, setPreviousChildMeetingData] =
    useState(null);
  const accessToken = localStorage.getItem("accessToken");
  useEffect(() => {
    if (props.meetingData?.parentMeetingId) {
      const fetchData = async () => {
        const payload = {
          id: props?.meetingData?._id,
          parentMeetingId: props.meetingData?.parentMeetingId,
        };

        const result = await dispatch(
          getImmediateFollowOnMeetingDetails(payload, accessToken)
        );

        if (result !== null) {
          // Do something with the result here
          setIsPreviousChildMeetingAvailable(true);
          setPreviousChildMeetingData(result);
        } else {
          setIsPreviousChildMeetingAvailable(false);
          if (
            props?.meetingData?.parentMeetingDetails &&
            props?.meetingData?.parentMeetingDetails?.length !== 0
          ) {
           
            setPreviousChildMeetingData(
              props?.meetingData?.parentMeetingDetails[0]
            );
          }
          if (props?.parentMeetingDetails) {
          
            setPreviousChildMeetingData(props?.parentMeetingDetails);
          }
        }
      };

      fetchData(); // call the async function
    } else {
      if (
        props?.meetingData?.parentMeetingDetails &&
        props?.meetingData?.parentMeetingDetails?.length !== 0
      ) {
        
        setPreviousChildMeetingData(
         
          props?.meetingData?.parentMeetingDetails[0]
        );
      }
    }
    return () => {
      setIsPreviousChildMeetingAvailable(false);
      setPreviousChildMeetingData(null);
    };
  }, [props?.meetingData]);

  useEffect(() => {
    const testTime = new Date().toLocaleTimeString();
    const is12Hour = testTime.includes("AM") || testTime.includes("PM");

    setIsAmPm(is12Hour);
  }, []);

  const meetingDatas = useSelector((state) => state.meeting);
  const dispatch = useDispatch();

  const { meetingData, isFetchedMeetingList } = props;

  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    date: "",
    fromTime: "",
    toTime: "",
    remarks: "",
  });
let agendaTime=0


props?.agendaDetails?.filter((agenda)=>agenda?.minutesDetail?.length==0).map((item)=>{

  agendaTime=agendaTime+item.timeLine;
})
  useEffect(() => {
    if (props.meetingData?.date) {
      var date = new Date(props.meetingData?.date);
      var dateString = new Date(
        date?.getTime() - date?.getTimezoneOffset() * 60000
      )
        .toISOString()
        .split("T")[0];
    }

    if (props.meetingData && !props?.isNewMeeting) {
      setFormData({
        ...formData,
        date: dateString ? dateString : null,
        fromTime: props.meetingData?.actualFromTime,
        toTime:props.meetingData?.actualToTime
      });
    }

     if (props.meetingData && props?.isNewMeeting) {
    

  const dateString2 = new Date().toISOString().split("T")[0];
  const currentTimes = getRoundedTime(30); // Round up to next 30-minute slot
  const endTime = addMinutesInHours(currentTimes, agendaTime); // Add agenda time

      setFormData({
        ...formData,
        date: dateString2 ? dateString2 : null,
        fromTime: currentTimes,
        toTime:endTime
      });

    }
    

    if (isFetchedMeetingList === true) {
      setErrors({});
      setFormData({
        ...formData,
        date: "",
        fromTime: "",
        toTime: "",
        remarks: "",
      });
      props.setIsRescheduleModalOpen(false);
    }

    return () => {
      dispatch(setErrorMessage(null));
      setErrors({});
      setFormData({
        ...formData,
        date: "",
        fromTime: "",
        toTime: "",
        remarks: "",
      });
    };
  }, [meetingData, isFetchedMeetingList, props.meetingData,props.isRescheduleModalOpen]);


  const handleSubmit2 = () => {
    const newErrors = validateForm(formData);
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      const payload = {
        ...formData,
        meetingId: meetingData._id,
        attendees: meetingData.attendees.map(
          ({
            rsvp,
            isAttended,
            empId,
            isEmployee,
            designation,
            companyName,
            isMeetingOrganiser,
            isAdmin,
            profilePicture,
            whatsAppNo,
            ...keepAttrs
          }) => keepAttrs
        ),
      };
      if (
        meetingData.actualToTime === formData.toTime &&
        meetingData.actualFromTime === formData.fromTime &&
        new Date(meetingData.actualDate).getTime() ===
          new Date(formData.date).getTime()
      ) {
    
        const errors = {};
        errors.remarks = "Please update date or time.";
        setErrors(errors);
      } else {
        if (props?.isNewMeeting) {
          delete payload?.meetingId;
        
          dispatch(
            newMeetingAsRescheduled(meetingData._id, payload, accessToken)
          );
        } else {
        
          dispatch(rescheduleMeeting(meetingData._id, payload, accessToken));
        }
      }
    }
  };


  const handleSubmit = async () => {
    const newErrors = validateForm(formData);
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      const payload = {
        ...formData,
        meetingId: meetingData._id,
      
        attendees: meetingData.attendees.map(
          ({
            rsvp,
            isAttended,
            empId,
            isEmployee,
            designation,
            companyName,
            isMeetingOrganiser,
            isAdmin,
            whatsAppNo,
            ...keepAttrs
          }) => keepAttrs
        ),
      };
      if (
        meetingData.actualToTime === formData.toTime &&
        meetingData.actualFromTime === formData.fromTime &&
         (
        formData.date ===
        dayjs(props?.meetingData?.actualDate).format("YYYY-MM-DD")
         )
      ) {
     
        const errors = {};
        errors.remarks = "Please update date or time.";
        setErrors(errors);
      } else {
        if (props?.isNewMeeting) {
           delete payload?.meetingId;
      
              setIsLoading(true);
          await dispatch(
            newMeetingAsRescheduled(meetingData._id, payload, accessToken)
          );
           setIsLoading(false);
        } else {
          setIsLoading(true);
          const result = await dispatch(
            rescheduleMeeting(meetingData._id, payload, accessToken)
          );
          setIsLoading(false);
          if (result && result?.status) {
            if (accessToken && props.fromMeetingList) {
              props.fetchMeetings("");
            }

            if (accessToken && !props.fromMeetingList) {
              dispatch(getSingleMeetingDetails(meetingData._id, accessToken));
            }
            setErrors({});
            setFormData({
              ...formData,
              date: "",
              fromTime: "",
              toTime: "",
              remarks: "",
            });
            props.setIsRescheduleModalOpen(false);
          }
        }
      }
    }
  };
  useEffect(() => {
    if (formData.toTime) {
      toDateFieldValidationCheck(formData.toTime);
    }
  }, [formData.toTime]); // Runs whenever toTime updates
  useEffect(() => {
    if (formData.fromTime) {
      fromDateFieldValidationCheck(formData.fromTime);
    }
  }, [formData.fromTime]); // Runs whenever toTime updates

  const closeModal = () => {
    setErrors({});
    setFormData({
      ...formData,
      remarks: "",
    });
    props.setIsRescheduleModalOpen(false);
    dispatch(setErrorMessage(null));

    if (props.meetingData?.date) {
      var date = new Date(props.meetingData?.date);
      var dateString = new Date(
        date?.getTime() - date?.getTimezoneOffset() * 60000
      )
        .toISOString()
        .split("T")[0];
    }

    if (props.meetingData) {
      setFormData({
        ...formData,
        remarks: "",
        date: dateString ? dateString : null,
        toTime: props.meetingData?.actualToTime,
        fromTime: props.meetingData?.actualFromTime,
      });
    }
  };

  const validateForm = (data) => {
    const errors = {};

    if (!formData.date.trim()) {
      errors.date = constantMessages.dateRequired;
    } else if (previousChildMeetingData?.actualDate) {
      const mDate = dayjs(formData.date, "YYYY-MM-DD");

      if (
        formData.date <
        dayjs(previousChildMeetingData?.actualDate).format("YYYY-MM-DD")
      ) {
        errors.date =
          isPreviousChildMeetingAvailable === false
            ? constantMessages.invalidFollowOnMeetingDate
            : constantMessages.invalidFollowOnMeetingDateForPreviousMeeting;
      }
     } else if (props?.meetingData?.actualDate && props.isNewMeeting) {


      if (
        formData.date <
        dayjs(props?.meetingData?.actualDate).format("YYYY-MM-DD")
      ) {
        errors.date ="Date can not be less than from current meeting date;"
          
      }
    }
    

    if (!data.fromTime.trim()) {
      errors.fromTime = constantMessages.timeRequired;
    } else if (previousChildMeetingData?.actualToTime) {
      if (
        formData?.date ===
          dayjs
            .tz(previousChildMeetingData?.actualDate, "UTC")
            .format("YYYY-MM-DD") &&
        formData.fromTime <= previousChildMeetingData?.actualToTime
      ) {
        errors.fromTime =
          isPreviousChildMeetingAvailable === false
            ? constantMessages.invalidFromMinuteForParentMeeting
            : constantMessages.invalidFromMinuteForPreviousMeeting;
      }




      const parentMeetingToTime = previousChildMeetingData?.actualToTime;

      const fromTimeArray = formData.fromTime.split(":");
      const fromTimeHour = fromTimeArray[0];
      const fromTimeMinute = fromTimeArray[1];
      const parentMeetingToTimeArray = parentMeetingToTime.split(":");
      const parentMeetingToHour = parentMeetingToTimeArray[0];
      const parentMeetingToMinute = parentMeetingToTimeArray[1];

      const mDate = dayjs(formData.date, "YYYY-MM-DD");

      if (
        mDate.format("YYYY-MM-DD") ===
        dayjs(previousChildMeetingData?.actualDate).format("YYYY-MM-DD")
      ) {
        if (fromTimeHour < parentMeetingToHour) {
          errors.fromTime = constantMessages.invalidFollowOnMeetingFromHour;
        } else if (
          fromTimeHour === parentMeetingToHour &&
          fromTimeMinute <= parentMeetingToMinute
        ) {
          errors.fromTime = constantMessages.invalidFollowOnMeetingFromMinute;
        }
      }
    } 
    
       else if (props?.meetingData?.actualDate && props.isNewMeeting) {

      if (
       formData?.date ===
        dayjs(props?.meetingData?.actualDate).format("YYYY-MM-DD")
        &&
         formData.fromTime <= props?.meetingData?.actualToTime
      ) {

       errors.fromTime  ="From time can not be less than from current meeting toTime;"
          
      }
    }

    
    
    
    else if (formData.toTime.trim()) {
      const fromTimeArray = formData.fromTime.split(":");
      const fromTimeHour = fromTimeArray[0];
      const fromTimeMinute = fromTimeArray[1];
      const toTimeArray = formData.toTime.split(":");
      const toTimeHour = toTimeArray[0];
      const toTimeMinute = toTimeArray[1];

      if (fromTimeHour > toTimeHour) {
        errors.fromTime = constantMessages.invalidFromHour;
      } else if (fromTimeHour === toTimeHour && fromTimeMinute > toTimeMinute) {
        errors.fromTime = constantMessages.invalidFromMinute;
      }
    }
    if (!data.toTime.trim()) {
      errors.toTime = constantMessages.timeRequired;
    } else if (formData.fromTime.trim()) {
      if (
        formData?.date ===
          dayjs
            .tz(previousChildMeetingData?.actualDate, "UTC")
            .format("YYYY-MM-DD") &&
        formData.fromTime <= previousChildMeetingData?.actualToTime
      ) {
        errors.fromTime =
          isPreviousChildMeetingAvailable === false
            ? constantMessages.invalidFromMinuteForParentMeeting
            : constantMessages.invalidFromMinuteForPreviousMeeting;
      }

      const fromTimeArray = formData.fromTime.split(":");
      const fromTimeHour = fromTimeArray[0];
      const fromTimeMinute = fromTimeArray[1];
      const toTimeArray = formData.toTime.split(":");
      const toTimeHour = toTimeArray[0];
      const toTimeMinute = toTimeArray[1];

      if (fromTimeHour > toTimeHour) {
        errors.toTime = constantMessages.invalidToHour;
      } else if (
        fromTimeHour === toTimeHour &&
        fromTimeMinute >= toTimeMinute
      ) {
        errors.toTime = constantMessages.invalidToMinute;
      }
    }

    if (!formData.remarks.trim()) {
      errors.remarks = constantMessages.reasonRequired;
    } else if (!regularExpressionForAgendaTitle.test(formData.remarks.trim())) {
      errors.remarks = constantMessages.titleRegexError;
    } else if (
      formData.remarks.trim().length < 3 ||
      formData.remarks.trim().length > 500
    ) {
      errors.remarks = constantMessages.largeStringLengthError;
    }

    return errors;
  };

  const fromDateFieldValidationCheck = useCallback(
    (e) => {
    
      const errors = {};
      if (!formData?.fromTime?.trim()) {
        errors.fromTime = constantMessages.timeRequired;
      } else if (formData?.toTime?.trim()) {
        if (previousChildMeetingData?.actualFromTime) {
          if (
            formData?.date ===
              dayjs
                .tz(previousChildMeetingData?.actualDate, "UTC")
                .format("YYYY-MM-DD") &&
            formData.fromTime <= previousChildMeetingData?.actualToTime
          ) {
            errors.fromTime =
              isPreviousChildMeetingAvailable === false
                ? constantMessages.invalidFromMinuteForParentMeeting
                : constantMessages.invalidFromMinuteForPreviousMeeting;
          }
        }
        else if (props?.meetingData?.actualDate && props.isNewMeeting) {

      if (
       formData?.date ===
        dayjs(props?.meetingData?.actualDate).format("YYYY-MM-DD")
        &&
         formData.fromTime <= props?.meetingData?.actualToTime
      ) {

       errors.fromTime  ="From time can not be less than from current meeting toTime;"
          
      }
    }

        

        const fromTimeArray = formData.fromTime.split(":");
        const fromTimeHour = fromTimeArray[0];
        const fromTimeMinute = fromTimeArray[1];
        const toTimeArray = formData.toTime.split(":");
        const toTimeHour = toTimeArray[0];
        const toTimeMinute = toTimeArray[1];

        if (fromTimeHour > toTimeHour) {
          errors.fromTime = constantMessages.invalidFromHour;
        } else if (
          fromTimeHour === toTimeHour &&
          fromTimeMinute >= toTimeMinute
        ) {
          errors.fromTime = constantMessages.invalidFromMinute;
        }
      }

      setErrors(errors);
    },
    [formData.fromTime]
  );

  const toDateFieldValidationCheck = (e) => {
    const errors = {};
    if (!formData.toTime.trim()) {
      errors.toTime = constantMessages.timeRequired;
    } else if (formData.fromTime.trim()) {
      if (previousChildMeetingData?.actualFromTime) {
        if (
          formData?.date ===
            dayjs
              .tz(previousChildMeetingData?.actualDate, "UTC")
              .format("YYYY-MM-DD") &&
          formData.fromTime <= previousChildMeetingData?.actualToTime
        ) {
          errors.fromTime =
            isPreviousChildMeetingAvailable === false
              ? constantMessages.invalidFromMinuteForParentMeeting
              : constantMessages.invalidFromMinuteForPreviousMeeting;
        }
      }
      const fromTimeArray = formData.fromTime.split(":");
      const fromTimeHour = fromTimeArray[0];
      const fromTimeMinute = fromTimeArray[1];
      const toTimeArray = formData.toTime.split(":");
      const toTimeHour = toTimeArray[0];
      const toTimeMinute = toTimeArray[1];

      if (fromTimeHour > toTimeHour) {
        errors.toTime = constantMessages.invalidToHour;
      } else if (
        fromTimeHour === toTimeHour &&
        fromTimeMinute >= toTimeMinute
      ) {
        errors.toTime = constantMessages.invalidToMinute;
      }
    }

    setErrors(errors);
  };

  const dateFieldValidationCheck = (e) => {
    const errors = {};
    if (!formData.date.trim()) {
      errors.date = constantMessages.dateRequired;
    }
    if (previousChildMeetingData?.actualFromTime) {
      if (
        formData?.date ===
          dayjs
            .tz(previousChildMeetingData?.actualDate, "UTC")
            .format("YYYY-MM-DD") &&
        formData.fromTime <= previousChildMeetingData?.actualToTime
      ) {
        errors.fromTime =
          isPreviousChildMeetingAvailable === false
            ? constantMessages.invalidFromMinuteForParentMeeting
            : constantMessages.invalidFromMinuteForPreviousMeeting;
      }
    }

    setErrors(errors);
  };

  const handleChange = (e) => {
    setErrors({});
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handledateChange = async (name, value) => {
    dispatch(setErrorMessage(null));

    setErrors({});
    if (value) {
      let formattedValue = value; // Default to the provided value
      let errors = {};
      // Ensure the value is formatted correctly if it's a Day.js object

      if (dayjs.isDayjs(value)) {
        if (name === "date") {
          formattedValue = dayjs(value)?.format("YYYY-MM-DD");

          const mDate = dayjs(value)?.format("YYYY-MM-DD");
          const previousChildMeetingDataActualDate = dayjs(
            previousChildMeetingData?.actualDate
          )?.format("YYYY-MM-DD");

          if (previousChildMeetingData?.actualDate) {
            if (
              mDate <
              dayjs
                .tz(previousChildMeetingData?.actualDate, "UTC")
                .format("YYYY-MM-DD")
            ) {
              errors.date =
                isPreviousChildMeetingAvailable === false
                  ? constantMessages.invalidFollowOnMeetingDate
                  : constantMessages.invalidFollowOnMeetingDateForPreviousMeeting;
            }
          }
          if (previousChildMeetingData?.actualFromTime) {
            if (
              mDate ===
                dayjs
                  .tz(previousChildMeetingData?.actualDate, "UTC")
                  .format("YYYY-MM-DD") &&
              formData.fromTime <= previousChildMeetingData?.actualToTime
            ) {
              errors.fromTime =
                isPreviousChildMeetingAvailable === false
                  ? constantMessages.invalidFromMinuteForParentMeeting
                  : constantMessages.invalidFromMinuteForPreviousMeeting;
            }
          }

            if (props?.meetingData?.actualDate && props.isNewMeeting) {

      if (
        formattedValue <
        dayjs(props?.meetingData?.actualDate).format("YYYY-MM-DD")
      ) {
        errors.date ="Date can not be less than from current meeting date;"
          
      }
    }

          setErrors(errors);
        } else if (name.includes("Time")) {
          formattedValue = value.format("HH:mm"); //  Store Time in 24-hour format
          if (previousChildMeetingData?.actualFromTime) {
            if (
              formData?.date ===
                dayjs
                  .tz(previousChildMeetingData?.actualDate, "UTC")
                  .format("YYYY-MM-DD") &&
              formattedValue <= previousChildMeetingData?.actualToTime
            ) {
              errors.fromTime =
                isPreviousChildMeetingAvailable === false
                  ? constantMessages.invalidFromMinuteForParentMeeting
                  : constantMessages.invalidFromMinuteForPreviousMeeting;
            }
          }

        if (props?.meetingData?.actualDate && props.isNewMeeting) {

      if (
       formData?.date ===
        dayjs(props?.meetingData?.actualDate).format("YYYY-MM-DD")
        &&
         formattedValue <= props?.meetingData?.actualToTime
      ) {

       errors.fromTime  ="From time can not be less than from current meeting toTime;"
          
      }
    }

          setErrors(errors);
        }
      }

      setFormData((prev) => {
        const updatedFormData = { ...prev, [name]: formattedValue };
        return updatedFormData;
      });
    }
  };

  const validateRemarks = () => {
    const errors = {};

    if (!formData.remarks.trim()) {
      errors.remarks = constantMessages.reasonRequired;
    } else if (!regularExpressionForAgendaTitle.test(formData.remarks.trim())) {
      errors.remarks = constantMessages.titleRegexError;
    } else if (
      formData.remarks.trim().length < 3 ||
      formData.remarks.trim().length > 500
    ) {
      errors.remarks = constantMessages.largeStringLengthError;
    }

    setErrors(errors);
    return errors;
  };


  return (
    <>
      <Modal
        show={props.isRescheduleModalOpen}
        onHide={closeModal}
        backdrop="static"
      >
        <div className="modal-header">
          <h4 className="modal-title">Reschedule Meeting</h4>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={closeModal}
          ></button>
        </div>
        <div className="modal-body delete-txt">
          <div className="mb-0">
            <div className="row">
              {previousChildMeetingData && (
                <>
                  <div className="form-group mb-2">
                    <div className="row">
                      <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                        <label className="mb-1">
                          {isPreviousChildMeetingAvailable
                            ? "Previous Meeting ID"
                            : "Parent Meeting ID"}
                        </label>
                      </div>
                      <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                        <p>{previousChildMeetingData?.meetingId}</p>
                      </div>
                    </div>
                  </div>
                  <div className="form-group mb-2">
                    <div className="row">
                      <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                        <label className="mb-1">
                          {isPreviousChildMeetingAvailable
                            ? "Previous Meeting Title"
                            : "Parent Meeting Title"}
                        </label>
                      </div>
                      <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                        <p>{previousChildMeetingData?.title}</p>
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="row">
                      <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                        <label className="mb-1">
                          {" "}
                          {isPreviousChildMeetingAvailable
                            ? "Previous Meeting Date & Time"
                            : "Parent Meeting Date & Time"}
                        </label>
                      </div>
                      <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                        <p>
                          {previousChildMeetingData?.date},
                          {previousChildMeetingData?.fromTime} to{" "}
                          {previousChildMeetingData?.toTime}{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="minutes-border"></div>
                </>
              )}

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
                  <div className="position-relative resp-input-margin-bottom">
                    <label className="mb-1 input-date">Date</label>
                    <span className="star-mark">*</span>
                    <DatePicker
                      name="date"
                      value={formData.date ? dayjs(formData.date) : null}
                      onChange={(newValue) =>
                        handledateChange("date", newValue)
                      }
                      className="svgg"
                      onBlur={dateFieldValidationCheck}
                      format="DD-MM-YYYY"
                      slotProps={{
                        textField: {
                          variant: "outlined",
                          fullWidth: true,
                          size: "small",
                          placeholder: "dd-mm-yyyy",
                          inputProps: {
                            onDragStart: (e) => e.preventDefault(),
                            onDrop: (e) => e.preventDefault(),
                            onDragOver: (e) => e.preventDefault(),
                          },
                        },
                        day: (params) => ({
                          sx: {
                            backgroundColor: dayjs().isSame(params.day, "day")
                              ? ""
                              : "inherit",
                            color: dayjs().isSame(params.day, "day")
                              ? "blue"
                              : "inherit",
                            borderRadius: "0%",
                            "&:hover": {
                              backgroundColor: dayjs().isSame(
                                params.day,
                                "day"
                              ),
                            },
                          },
                        }),
                      }}
                    />
                  </div>
                  {errors.date && (
                    <span className="error-message">{errors.date}</span>
                  )}
                </div>
              </LocalizationProvider>

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
                  <div className="position-relative resp-input-margin-bottom">
                    <label className="mb-1">From Time</label>
                    <span className="star-mark">*</span>
                    <TimePicker
                      name="fromTime"
                      value={
                        formData.fromTime
                          ? dayjs(`2000-01-01T${formData.fromTime}`)
                          : null
                      }
                      onChange={(newValue) =>
                        handledateChange("fromTime", newValue)
                      }
                      onBlur={fromDateFieldValidationCheck}
                      ampm={true}
                      timeSteps={{ minutes: 1 }}
                      format="HH:mm"
                      slotProps={{
                        textField: {
                          variant: "outlined",
                          fullWidth: true,
                          size: "small",
                          placeholder: "hh:mm",
                          inputProps: {
                            onDragStart: (e) => e.preventDefault(),
                            onDrop: (e) => e.preventDefault(),
                            onDragOver: (e) => e.preventDefault(),
                          },
                        },
                      }}
                    />
                  </div>
                  {errors.fromTime && (
                    <span className="error-message">{errors.fromTime}</span>
                  )}
                </div>
              </LocalizationProvider>

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
                  <div className="position-relative resp-input-margin-bottom">
                    <label className="mb-1">To Time</label>
                    <span className="star-mark">*</span>
                    <TimePicker
                      name="toTime"
                      value={
                        formData.toTime
                          ? dayjs(`2000-01-01T${formData.toTime}`)
                          : null
                      }
                      onChange={(newValue) =>
                        handledateChange("toTime", newValue)
                      }
                      ampm={true}
                      timeSteps={{ minutes: 1 }}
                      format="HH:mm"
                      slotProps={{
                        textField: {
                          variant: "outlined",
                          fullWidth: true,
                          size: "small",
                          placeholder: "hh:mm",
                          inputProps: {
                            onDragStart: (e) => e.preventDefault(),
                            onDrop: (e) => e.preventDefault(),
                            onDragOver: (e) => e.preventDefault(),
                          },
                        },
                      }}
                    />
                  </div>
                  {errors.toTime && (
                    <span className="error-message">{errors.toTime}</span>
                  )}
                </div>
              </LocalizationProvider>
            </div>

            <div className="row resp-mt-0">
              <div className="col-md-12 delete-txt">
                <label className="mb-1 input-date">
                  Reason
                  <span className="star-mark">*</span>
                </label>

                <textarea
                  cols="40"
                  rows="4"
                  id="remark"
                  name="remarks"
                  onBlur={validateRemarks}
                  onChange={handleChange}
                  value={formData.remarks}
                  placeholder="Enter your reason here..."
                  required
                ></textarea>
                <p className="success-message">
                  {checkCharacterLeft(formData.remarks)} Characters left
                </p>
                {errors.remarks && (
                  <span className="error-message">{errors.remarks}</span>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          {!isLoading ? (
            <button
              type="button"
              onClick={handleSubmit}
              className="Mom-btn btn btn-secondary bg-primary border-primary"
            >
              <p>Reschedule</p>
            </button>
          ) : (
            <SmallLoaderButton />
          )}
        </div>
        {meetingDatas?.errorMessage && (
          <div className="attendee-array-error-messages">
            <ul className="error-list error-message">
              {(Array.isArray(meetingDatas.errorMessage)
                ? meetingDatas.errorMessage
                : [meetingDatas.errorMessage]
              ).map((error, index) => (
                <li key={index} className="error-item">
                  {error}
                </li>
              ))}
            </ul>
          </div>
        )}
      </Modal>
    </>
  );
});

export default RescheduleMeetingModal;
